/**
 * @nullable
 */
export type ArticleInstancePlacementSourceType =
    | (typeof ArticleInstancePlacementSourceType)[keyof typeof ArticleInstancePlacementSourceType]
    | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleInstancePlacementSourceType = {
    Panel: 'Panel',
    UnsavedGroup: 'UnsavedGroup',
    SavedGroup: 'SavedGroup',
    Corner: 'Corner'
} as const;
